;(() => {
  function isTextClamped($elm) {
    return $elm.scrollHeight > $elm.clientHeight
  }

  function initManifestLineClamp($wrapper) {
    const $desc = $wrapper.querySelector('[data-manifest-description]')
    const $btn = $wrapper.querySelector('[data-manifest-description-all]')

    if (isTextClamped($desc)) {
      $btn.classList.remove('hidden')
    }

    $btn.addEventListener('click', (e) => {
      e.preventDefault()
      $desc.classList.toggle('line-clamp-3')
      $btn.classList.toggle('hidden')
    })
  }

  document
    .querySelectorAll('[data-manifest-description-wrapper]')
    .forEach(initManifestLineClamp)
})()
